import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import PropTypes from "prop-types";
import styled from "styled-components";
import { LoadingSpinnerButton, PathwayButton } from "./PathwayButtons";
import { FlexibleButtonModalFooter } from "../StyledComponents/PathwayModal";
import { ErrorMessage, WarningMessage } from "./Alerts/PathwayAlertMessages";

export const ModalS = (props) => {
    const handleSubmit = (e) => {
        props.handleSubmit(e);
        if (props.submitAndToggle) {
            props.toggleModal();
        }
    };

    const primaryButton = !props.hidePrimaryButton && (
        <LoadingSpinnerButton
            loading={props.isLoading}
            onClick={handleSubmit}
            disabled={props.disabled}
            buttonCyData={props.buttonCyData || props.dataCy + "-submit-button"}
        >
            {props.primaryButtonText}
        </LoadingSpinnerButton>
    );

    const cancelButton = (
        <PathwayButton
            color="secondary"
            onClick={props.toggleModal}
            data-cy={props.dataCy ? props.dataCy + "-cancel-button" : undefined}
        >
            {props.secondaryButtonText || "Abbrechen"}
        </PathwayButton>
    );

    return (
                <Modal
            isOpen={props.isOpen}
            toggle={props.toggleModal}
            size={props.size}
            data-cy={props.dataCy + "-modal"}
        >
            {/* The prototype heads a dialog with an eyebrow naming the context it acts in —
                the section, or the client being edited — above the title. */}
            <ModalHeader toggle={props.toggleModal}>
                {props.eyebrow && <ModalEyebrow>{props.eyebrow}</ModalEyebrow>}
                {props.title}
            </ModalHeader>
            <ModalBody data-cy={props.dataCy + "-modal-body"}>
                {props.children}
                <WarningMessage useTopMargin={true} useBottomMargin={false}>
                    {props.warningMessage}
                </WarningMessage>
                <ErrorMessage useTopMargin={true} useBottomMargin={false}>
                    {props.errorMessage}
                </ErrorMessage>
            </ModalBody>
            {props.leftFooterContent ? (
                <SpaceBetweenModalFooter>
                    <FooterSide>{props.leftFooterContent}</FooterSide>
                    <FooterSide>
                        {cancelButton}
                        {primaryButton}
                    </FooterSide>
                </SpaceBetweenModalFooter>
            ) : (
                /* Cancel first, the committing action last — the prototype puts the
                   primary button rightmost, where the eye finishes. */
                <FlexibleButtonModalFooter>
                    {cancelButton}
                    {primaryButton}
                </FlexibleButtonModalFooter>
            )}
        </Modal>
    );
};

const ModalEyebrow = styled.div`
    margin-bottom: 3px;
    font-size: var(--pw-text-2xs);
    font-weight: var(--pw-weight-bold);
    letter-spacing: var(--pw-tracking-eyebrow);
    text-transform: uppercase;
    color: var(--pw-brand-cyan);
`;

const SpaceBetweenModalFooter = styled(ModalFooter)`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const FooterSide = styled.div`
    display: flex;
    align-items: center;
    gap: var(--gap-m, 12px);
`;

ModalS.propTypes = {
    title: PropTypes.string.isRequired,
    // The context the dialog acts in, shown above the title.
    eyebrow: PropTypes.node,
    primaryButtonText: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    children: PropTypes.node.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    warningMessage: PropTypes.string,
    errorMessage: PropTypes.string,
    hidePrimaryButton: PropTypes.bool,
    size: PropTypes.any,
    secondaryButtonText: PropTypes.string,
    buttonCyData: PropTypes.string,
    dataCy: PropTypes.string,
    leftFooterContent: PropTypes.node,
};
